import React from 'react';
import ReactDOM from 'react-dom/client';
import '@jaylabs/ui/dist/index.css';
import './styles/utilities.css';
import './index.css';
import App from './App';
import { ColorModeProvider } from './components/ui/color-mode';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <App />
    </ColorModeProvider>
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => console.log('Service Worker registered successfully!'),
  onUpdate: (registration) => {
    console.log('New content available; please refresh.');
    if (window.confirm('New version available! Would you like to update?')) {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
});